import api from "./api";
import auth from "./auth";
import _ from "lodash";

const esc = encodeURIComponent;

const query = (param) => {
  return Object.keys(param).map(q => `${esc(q)}=${param[q]}`).join('&');
}

export default {
  getBrands() {
    return new Promise((resolve, reject) => {
      api.get(
        'organization-service/brand/list',
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBranches() {
    return new Promise((resolve, reject) => {
      api.get(
        'organization-service/branch/list',
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBrandCategories(brand_uuid) {
    return new Promise((resolve, reject) => {
      api.get(
        `estore-service/v1/cms/estore/brand/category/${brand_uuid}`,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getProducts(page) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v1/cms/estore/product/inventory/list/${page}`,
        null,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBranchProducts(payload) {
    const { param } = payload;
    const isParam = param && !_.isEmpty(param);
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/brand/${payload.brand_uuid}/branch/${payload.branch_uuid}/products`,
        isParam ? param : null,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBranchSimpleProductDetail(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v1/cms/estore/product/simple/view/${payload.product_inventory_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getVariableProductDetail(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v1/cms/estore/product/variable/view/${payload.product_inventory_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  registGuestUser(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `customer-service/v2/cms/customer/chat-guest/register`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  createCustomerInbox(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/inbox/${payload.brand_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBrandInbox(payload) {
    const { param } = payload;
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/inbox/${payload.brand_uuid}/list`,
        param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getBrandThread(payload) {
    const { param } = payload;
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/inbox/${payload.brand_uuid}/thread/${payload.thread_uuid}`,
        param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getCustomerCart(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  addItemToCart(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}/item`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  updateCart(payload) {
    return new Promise((resolve, reject) => {
      api.put(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}/item/${payload.cart_item_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  removeCartItem(payload) {
    return new Promise((resolve, reject) => {
      api.delete(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}/item/${payload.cart_item_uuid}`,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getCheckoutLink(payload) {
    return new Promise((resolve, reject) => {
      api.get(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}/checkout-link`,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getTrackingLink(payload) {
    return new Promise((resolve, reject) => {
      api.get(
        `estore-service/v2/cms/estore/cart/${payload.customer_uuid}/brand/${payload.brand_uuid}/tracking-link`,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  sendMessage(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/inbox/${payload.brand_uuid}/thread/${payload.thread_uuid}/send-message`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  isMultiplePurchaseAllowed(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `organization-service/settings/view/${payload.merchant_uuid}`,
        payload.param,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  },
  getCustomerOrderStatus(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `estore-service/v2/cms/estore/order/status`,
        payload,
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  }
}
